import React, { type ComponentProps, type ElementType } from 'react';

import { Link } from '@mui/material';

import Markdown from '@/components/Markdown';
import Tooltip from '@/components/Tooltip';
import { Z_INDEX } from '@/constants/z-index';
import { GX_REGEX } from '@/features/AIChat/AskGXDrawer/utils/gxCodes';
import type { AIMessage } from '@/features/AIChat/types/chat';
import WidgetMapper from '@/features/AIChat/widgets/WidgetMapper';

import type { ExtraProps } from 'react-markdown';

const AssistantLink: ElementType<ComponentProps<'a'> & ExtraProps> = ({
  node,
  children,
  ...props
}) => (
  <Tooltip
    sx={{
      zIndex: Z_INDEX.panel
    }}
    title='Click to see index information'
    variant='secondary'
  >
    <Link
      {...props}
      color='textPrimary'
      rel='noopener noreferrer'
      sx={{ textDecorationColor: 'inherit' }}
      target='_blank'
    >
      {children}
    </Link>
  </Tooltip>
);

const AIContent = ({ msg }: { msg: AIMessage }) => {
  return (
    <>
      {msg.content.map(part => {
        switch (part.kind) {
          case 'text':
            return (
              <Markdown
                key={part.text}
                customMarkdown={{
                  a: AssistantLink
                }}
              >
                {part.text.replace(GX_REGEX, match => `[${match}](/${match})`)}
              </Markdown>
            );
          case 'tool_result':
            if (part.display === 'table') {
              return (
                <WidgetMapper
                  key={part.tool_call_id}
                  widgetData={part}
                />
              );
            }
            return null;
          default:
            return null;
        }
      })}
    </>
  );
};

export default AIContent;
